import i18next from 'i18next'
import { toast } from 'sonner'

export function copyWithToast(text: string) {
  navigator.clipboard.writeText(text).then(
    () => toast.success(i18next.t('common.copied'), { duration: 1500 }),
    () => toast.error(i18next.t('common.copyFailed')),
  )
}
